import { GraphQLResult } from "@aws-amplify/api-graphql";
import { debounce, TextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Autocomplete from "@mui/material/Autocomplete";
import React, { useCallback, useEffect, useState } from "react";
import {
  SearchResidentsQuery,
  UpdateResidentInput,
  SearchableResidentFilterInput,
} from "../../API";
// personType was here
import IntakeService from "./IntakeService";

const useStyles = makeStyles((theme) => ({
    searchBar: {
        display: 'flex',
        alignItems: 'center'
    },
}));

interface Props {
    id?: string,
    community?: string,
    size?: 'medium' | 'small',
    onSelect?: (person: PersonId) => void;
}

export interface PersonId {
    id: string,
    detail?: UpdateResidentInput 
}

export default function PersonSearchBox(props: Props) {

    const classes = useStyles();

    const [person, setPerson] = useState<UpdateResidentInput>();

    useEffect(() => {
        if (props.id) {
            // switch (props.personType) {
            //     case PersonType.EMPLOYEE:
            //         IntakeService.getEmployee(props.personId).then((e) => {
            //             if (e.data?.getEmployee) {
            //                 setPerson(e.data.getEmployee);
            //             }
            //         });
            //         break;
            //     case PersonType.RESIDENT:
                     IntakeService.getResident(props.id).then((r) => {
                         if (r.data?.getResident) {
                             setPerson(r.data.getResident);
                         }
                     });
            //         break;
            //     case PersonType.EXTERNALUSER:
            //         IntakeService.getOther(props.personId).then((o) => {
            //             if (o.data?.getExternalUser) {
            //                 setPerson(o.data.getExternalUser);
            //             }
            //         });
            //         break;
            // }
        }
    }, [props.id]);

    // FIXME: get rid of "any" types
    // const [employeeMatches, setEmployeeMatches] = useState<any[]>([]);
    const [residentMatches, setResidentMatches] = useState<any[]>([]);
    // const [externalUsersMatches, setExternalUsersMatches] = useState<any[]>([]);

    const handleSearchChange = async (pSearchText: string, pCommunity?: string) => {
        if (pSearchText.length > 2) {
            try {
                // if (pPersonType === PersonType.EMPLOYEE) {
                //     const employees = [] as any[];
                //     let nextToken;
                //     while (nextToken !== null) {
                //         let filter: SearchableEmployeeFilterInput | undefined;
                //         if (pCommunity) {
                //             filter = {
                //                 community: {
                //                     eq: pCommunity
                //                 }
                //             };
                //         }
                //         const searchResult = await IntakeService.searchEmployees(pSearchText, filter, 1000, nextToken) as GraphQLResult<SearchEmployeesQuery>;
                //         nextToken = searchResult.data?.searchEmployees?.nextToken;
                //         if (searchResult.data?.searchEmployees?.items) {
                //             employees.push(...searchResult.data.searchEmployees.items);
                //         } else {
                //             EventService.log('error', 'Error searching ', searchResult.errors);
                //         }
                //     }
                //     setEmployeeMatches(employees);
                // }
                // if (pPersonType === PersonType.RESIDENT) {
                    const residents = [] as any[];
                    let nextToken;
                    while (nextToken !== null) {
                        let filter: SearchableResidentFilterInput | undefined;
                        if (pCommunity) {
                            filter = {
                                community: {
                                    eq: pCommunity
                                }
                            };
                        }
                        const searchResult = await IntakeService.searchResidents(pSearchText, filter, 1000, nextToken) as GraphQLResult<SearchResidentsQuery>;
                        nextToken = searchResult.data?.searchResidents?.nextToken;
                        if (searchResult.data?.searchResidents?.items) {
                            residents.push(...searchResult.data.searchResidents.items);
                            console.log(...searchResult.data.searchResidents.items)
                            console.log(searchResult)
                        } else {
                            console.log("error")
                        }
                    }
                    console.log(residents);
                    setResidentMatches(residents);
                // }
                // if (pPersonType === PersonType.EXTERNALUSER) {
                //     const externalUsers = [] as any[];
                //     let nextToken;
                //     while (nextToken !== null) {
                //         let filter: SearchableExternalUserFilterInput | undefined;
                //         if (pCommunity) {
                //             filter = {
                //                 community: {
                //                     eq: pCommunity
                //                 }
                //             };
                //         }
                //         const searchResult = await IntakeService.searchExternalUsers(pSearchText, filter, 1000, nextToken) as GraphQLResult<SearchExternalUsersQuery>;
                //         nextToken = searchResult.data?.searchExternalUsers?.nextToken;
                //         if (searchResult.data?.searchExternalUsers?.items) {
                //             externalUsers.push(...searchResult.data.searchExternalUsers.items);
                //         } else {
                //             EventService.log('error', 'Error searching ', searchResult.errors);
                //         }
                //     }
                //     setExternalUsersMatches(externalUsers);
                // }
            } catch (err) {
               console.log("error", err);
            }
        }
    }

    const [searchText, setSearchText] = useState<string>('');
    const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    }

    const debouncedSearchChange = useCallback(
        debounce((pSearchText: string, pCommunity?: string) => {
            handleSearchChange(pSearchText, pCommunity);
        }, 500),
        []
    );
    // // Load records when the selection or search changes
    // useEffect(() => {
    //     debouncedSearchChange(searchText, props.personType || PersonType.EMPLOYEE, props.community);
    // }, [searchText, debouncedSearchChange, props.personType, props.community]);

      // Load records when the selection or search changes
      useEffect(() => {
        debouncedSearchChange(searchText, props.community);
    }, [searchText, debouncedSearchChange, props.community]);


    return (
        <React.Fragment>
            <Autocomplete
                className={classes.searchBar}
                autoComplete
                autoHighlight
                autoSelect
                
                disableClearable
                options={residentMatches}
                //     props.personType === undefined
                //         ? employeeMatches.concat(residentMatches)
                //         : (props.personType === PersonType.EMPLOYEE ? employeeMatches : (props.personType === PersonType.RESIDENT ? residentMatches : externalUsersMatches))
                // }
                getOptionLabel={(o) => {
                    return (
                        o.firstName + ' ' + o.lastName + ' Resident ID: ' + o.id
                    )


                    // props.personType === PersonType.RESIDENT
                    //     ? (o.firstName + ' ' + o.lastName + ' Resident ID: ' + o.id)
                    //     : (props.personType === PersonType.EMPLOYEE
                    //         ? o.firstName + ' ' + o.lastName + ' Emp ID: ' + o.id
                    //         : o.firstName + ' ' + o.lastName + ' External User ID: ' + o.id);
                }}
                onChange={(_, value) => {
                    if (props.onSelect) {
                        props.onSelect({ id: value.id, detail: value });
                    }
                }}
                // FIXME:
                defaultValue={person}
                value={person}
                // getOptionSelected={(o, v) => {
                //     console.log(o.id, v.id);
                //     return o.id === v.id;
                // }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        size={props.size}
                        onChange={handleTextChange}
                        value={person}
                        margin="normal"
                        variant="outlined"
                        InputProps={{ ...params.InputProps, type: 'search' }}
                    />
                )}
            />
        </React.Fragment>
    );
}